module.exports = __webpack_public_path__ + "img/logo_square.8cc44918.png";